module.exports = __webpack_public_path__ + "img/5.8a426f76.png";